export type ViewMode = 'create' | 'view' | 'preview' | 'edit' | 'execute' | 'none' | 'speech';
